import {useDispatch, useSelector} from "react-redux";
import React from "react";
import {TABLES} from "../../../../Apis/Tables";
import CustomTh from "../../../../components/table/CustomTh";
import CustomTd from "../../../../components/table/CustomTd";
import {permissionObj} from "../../../../Helpers/permission";
import DropDownMenuProfile from "../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../components/DropDown/DropDownMenuItem";
import TableFunction from "../../../../components/table/TableFunction";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import {SimpleSearch} from "../../../../reduxToolkit/Search/SearchApi";
import {DeleteIconsOptions, UpdateIconsOptions} from "../../../../components/buttons/IconButtons";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
/**
 * Hook for managing the logic of the Distribution Center table view.
 *
 * @param {Object} props
 * @param {Array} props.selectedList - List of selected rows.
 * @param {Function} props.setSelectedList - Function to update selected rows.
 * @param {Function} props.setBodyForExport - Function to store the search/export body.
 * @param {boolean} props.modified - Flag to trigger data refresh.
 * @param {Function} props.setModified - Function to update the modified flag.
 * @param {Function} props.setIsAllChecked - Function to toggle all-row selection.
 * @param {string} props.searchElement - Search term for simple search.
 * @param {Object|null} props.results - Results from API to be displayed.
 * @param {Function} props.setResults - Function to update search results.
 * @param {Function} props.setAddShow - Function to show add/edit form.
 * @param {Function} props.setUpdateData - Function to store data for update.
 * @param {Function} props.setIsUpdate - Function to toggle update mode.
 * @param {Function} props.setDeleteDistributionCenter - Function to toggle deletion modal.
 */

export const DistributionCenterTableApp = ({selectedList, setSelectedList, setBodyForExport,
                                               modified, setModified, setIsAllChecked, searchElement, results, setResults,
                                               setAddShow, setUpdateData, setIsUpdate,
                                               setDeleteDistributionCenter
                                           }) =>
{
    const dispatch = useDispatch();
    const tableId = 'tbl_dcta_table';
    const searchId = 'tbl_dcta_table';
    const DEV = useSelector(state => state?.CommonsSlice?.development);
    const { permission } = useSelector(state => state.authenticatioauthennSlice);
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    const option = TABLES.DISTRIBUTION_CENTER;
    const columnActions = (DEV ||
        permission?.includes(permissionObj.WEB_DISTRIBUTION_CENTER_UPDATE) ||
        permission?.includes(permissionObj?.WEB_DISTRIBUTION_CENTER_DELETE));

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} classes="w-95">{t('distribution_center')}</CustomTh>,
        ];
    }

    const getTbody = () => {
        if(!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        const body = results?.content?.map(item => {
            return (
                <>
                    <CustomTd tableId={tableId}>
                        {item?.name}
                    </CustomTd>
                </>
            );
        });

        return {
            body,
            data: results?.content
        };
    };

    const getActionsButtons = (item, index) => {
        return <>
            <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle}
                                 menuId={`menu-${item.id}`} isAccordion={true}>
                {(DEV || permission?.includes(permissionObj.WEB_DISTRIBUTION_CENTER_UPDATE)) && (
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('update')}
                        click={() => {
                            setAddShow(true);
                            setUpdateData(item);
                            setIsUpdate(true);
                        }}
                        icon={<UpdateIconsOptions />}
                    />)
                }
                {(DEV || permission?.includes(permissionObj?.WEB_DISTRIBUTION_CENTER_DELETE)) && (
                    <DropDownMenuItem
                        index={item.id}
                        handleClose={handleClose}
                        name={t('delete')}
                        click={() => {
                            setSelectedList([item.id]);
                            setDeleteDistributionCenter(true);
                        }}
                        icon={<DeleteIconsOptions />}
                        fontColor='font-color-error-600'
                        iconColor={'icon-color-error-code-600'}
                    />
                )
                }
            </DropDownMenuProfile>
        </>;
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, model:option, key:searchElement });
        setBodyForExport(body);
        dispatch(SimpleSearch({ body })).then(
            ({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults(data);
                }
            }
        );
    };

    const {t, thead, tbody, handleCheckboxChange,
        openMenu, handleMenuToggle, handleClose, handleDeleteAll,
        pagination, page, rowsPerPage} = TableFunction({
        selectedList,
        setSelectedList,
        data:results,
        getThead,
        getTbody,
        labelRowsPerPage:'distribution_center_per_page',
        fixedPagination:true,
        hasContainer:false,
        setIsAllChecked,
        searchElement, //New
        getData,//New
        modified,//New
        setModified//New
    });

    return {
        DEV, permission,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        handleCheckboxChange,
        pagination, page, rowsPerPage,
        contractorId, supplierId,
        results, setResults,
        handleDeleteAll,
        columnActions
    };
};
